module.exports = __webpack_public_path__ + "static/img/1.6dda75c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/1.jpg
// module id = 3EFN
// module chunks = 12